import React from 'react';

export const LoadingSpinner = ({ size = 'md', color = 'blue' }) => {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };
  
  const colorClasses = {
    blue: 'border-blue-500',
    white: 'border-white',
    gray: 'border-gray-400'
  };

  return (
    <div className={`${sizeClasses[size]} border-2 ${colorClasses[color]} border-t-transparent rounded-full animate-spin`} />
  );
};

export const PageLoader = ({ text = 'Loading...' }) => (
  <div className="min-h-screen bg-deep-black flex items-center justify-center">
    <div className="text-center">
      <LoadingSpinner size="lg" color="blue" />
      {text && <p className="mt-4 text-gray-300">{text}</p>}
    </div>
  </div>
);

export const ButtonLoader = () => (
  <div className="flex items-center justify-center gap-2">
    <LoadingSpinner size="sm" color="white" />
    <span>Processing...</span>
  </div>
);